import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AppService } from "src/app/_services/app.service";
import { AuthService } from "src/app/_services/auth.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { PusherService } from "src/app/_services/pusher.service";
import { SessionStorageService } from "src/app/_services/session-storage.service";
import { SecondStepData } from "src/app/models/register-state.interface";

type DocType = "KBIS" | "URSSAF" | "votre_photo" | "Piece_d_identite";

type DocumentStatus = {
  file: any;
  type: DocType;
  status: string;
};

type Docs = {
  [key: string]: DocumentStatus;
};
@Component({
  selector: "app-second-step",
  templateUrl: "./second-step.page.html",
  styleUrls: ["./second-step.page.scss"],
})
export class SecondStepPage implements OnInit {
  registerFormProvider: FormGroup = this.fb.group({
    societe: ["", Validators.required],
    experience: [""],
    diploma: [""],
    speciality_id: [""],
    acceptCGV: [false, Validators.requiredTrue],
  });
  selectedDomainId?: number;
  selectedDomainName: string = "";
  selectedTypeId?: string;
  selectedTypeName: string = "";
  selectedSpecialiteName: string = "";
  selectedSpecialiteList: any[] = [];

  selectedDomainId1?: number;
  selectedDomainName1: string = "";
  selectedTypeId1?: string;
  selectedTypeName1: string = "";

  selectedSpecialiteList1: any[] = [];
  docs: Docs = {
    KBIS: {
      file: null,
      type: "KBIS",
      status: "EMPTY",
    },
    URSSAF: {
      file: null,
      type: "URSSAF",
      status: "EMPTY",
    },
    votre_photo: {
      file: null,
      type: "votre_photo",
      status: "EMPTY",
    },
    Piece_d_identite: {
      file: null,
      type: "Piece_d_identite",
      status: "EMPTY",
    },
  };
  @Input() step: any = 0;
  @Input() f: any = {};
  @Output() ValidForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() goTo: EventEmitter<any> = new EventEmitter<any>();
  @Input() role: any;
  @Input() passwordVal: any;
  textType = "password";
  selectedExperience: string = "";
  submitted = false;
  isLoading = false;
  files: any = ["", "", ""];
  filesIndicatorImage: string[] = [
    "../../../../assets/icon/doc-upload.png",
    "../../../../assets/icon/doc-upload.png",
    "../../../../assets/icon/doc-upload.png",
  ];
  filesName: string[] = [
    "Partager vos documents",
    "Partager vos documents",
    "Partager vos documents",
  ];
  domanModal: boolean = false;
  typeModal: boolean = false;
  specialteModal: boolean = false;
  cgvModal: boolean = false;
  domainList: any = [];
  specialityList: any = [];
  isSpeciality = false;
  businessTypes = [
    "EL",
    "EIRL",
    "EURL",
    "SARL",
    "SAS",
    "SA",
    "Entreprise publique",
    "ESS",
    "Micro-entreprise",
    "Auto-entrepreneur",
  ];
  allowedMimeTypes = [
    "image/jpeg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  selectedItems: any = [];
  domainSelected: boolean = false;
  specialitySelected: boolean = false;
  companyTypeSelected: boolean = false;
  domaineId: any;
  emailError: boolean = false;
  cgvLastUpdate: string = new Date().toLocaleDateString('fr-FR');
  missingDocErrors: { [key: string]: boolean } = {
    URSSAF: false,
    KBIS: false,
    votre_photo: false,
    Piece_d_identite: false,
  };
  fileValidationErrors: { [key: string]: string } = {
    URSSAF: '',
    KBIS: '',
    votre_photo: '',
    Piece_d_identite: '',
  };
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private pusherService: PusherService
  ) { }
  ngOnInit() {
    this.appService.getDomain().subscribe((res: any) => {
      this.domainList = res.body.data.filter((domainde: any) => {
        return domainde.nom != "Transporteur";
      });

      // Restore form data after domains are loaded
      this.restoreFormData();
    });

    // Apply passed form data if available (from parent component)
    if (this.f) {
      this.registerFormProvider.patchValue(this.f);
    }

    // Auto-save form data on changes
    this.registerFormProvider.valueChanges.subscribe(() => {
      this.autoSaveFormData();
    });
  }
  ionViewWillEnter() { }
  ngOnChanges(changes: SimpleChanges) {
    this.passwordVal = this.f?.password;
    this.registerFormProvider.patchValue(this.f);
  }
  get provider() {
    return this.registerFormProvider.controls;
  }

  nextSteps(stepper: any) {
    this.step = stepper;
    this.goTo.emit(this.step);
  }

  prev(stepper: any) {
    this.step = stepper;
    this.goTo.emit(this.step);
  }

  confirmPassword(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password_confirm = control.value;
      try {
        var password = this.passwordVal;
      } catch (err) {
        console.error(err);
      }
      if (password === password_confirm) {
        return null;
      }
      return { password_mismatch: true };
    };
  }

  togglePasswordVisibility() {
    this.textType = this.textType === "text" ? "password" : "text";
  }
  selectExperience(experience: string) {
    this.selectedExperience = experience;
    this.registerFormProvider.patchValue({
      experience: this.selectedExperience,
    });
  }

  /**
   * Gère les erreurs Stripe provenant de l'API et affiche un message à l'utilisateur si besoin.
   * Retourne true si une erreur Stripe a été détectée et traitée, sinon false.
   */
  stripeErrorHandler(errors: any): boolean {
    if (errors && errors.stripe) {
      this.appService.presentToast(errors.stripe.message || "Erreur Stripe lors du paiement.", "danger");
      return true;
    }
    return false;
  }

  // Formater le numéro de téléphone pour l'envoi au serveur
  private formatPhoneForSubmission(phoneNumber: string): string {
    if (!phoneNumber) return "";

    // Si le numéro ne commence pas par +, ajouter le préfixe du pays
    if (!phoneNumber.startsWith('+')) {
      // Récupérer le préfixe du pays depuis les données phone_field
      if (this.f.phone_field && this.f.phone_field.dialCode) {
        return this.f.phone_field.dialCode + phoneNumber;
      }
    }

    return phoneNumber;
  }

  private normalizeTextForSubmission(value: string): string {
    if (!value) return "";
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[’`]/g, "'")
      .replace(/\s+/g, " ")
      .trim();
  }

  private normalizePostalCodeForSubmission(value: string): string {
    if (!value) return "";
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "")
      .trim();
  }

  submitFormProvider() {
    this.submitted = true;
    this.isLoading = true;
    // this.f.code = this.f.code !== "" ? this.f.code : "+33";
    if (
      this.registerFormProvider.invalid ||
      !this.selectedDomainId ||
      !this.selectedTypeName ||
      !this.registerFormProvider.get('acceptCGV')?.value
    ) {
      this.isLoading = false;
      return;
    }

    // Validation des documents requis (URSSAF, KBIS, votre_photo, Piece_d_identite)
    const requiredDocs = [
      { key: 'URSSAF', label: 'URSSAF' },
      { key: 'KBIS', label: 'KBIS' },
      { key: 'votre_photo', label: 'Photo' },
      { key: "Piece_d_identite", label: "Pièce d'identité" }
    ];

    const missingDocs = requiredDocs.filter((d) => {
      const doc = this.docs?.[d.key];
      // Considérer valide si déjà accepté, sinon un fichier est requis
      const isAccepted = doc && doc.status === 'ACCEPTED';
      const hasFile = doc && !!doc.file;
      return !(isAccepted || hasFile);
    });

    if (missingDocs.length > 0) {
      this.isLoading = false;
      // Marquer les erreurs pour l'affichage UI (true = manquant)
      const nextErrors: { [key: string]: boolean } = {
        URSSAF: false,
        KBIS: false,
        votre_photo: false,
        Piece_d_identite: false,
      };
      missingDocs.forEach((d) => (nextErrors[d.key] = true));
      this.missingDocErrors = nextErrors;
      this.cdr.detectChanges();
      return;
    }

    const formData = new FormData();

    for (const key of Object.keys(this.docs)) {
      const doc = this.docs[key];
      if (doc && doc.file) {
        formData.append(`documents[${key}][file]`, doc.file);
        formData.append(`documents[${key}][file_type]`, doc.type);
      }
    }

    // Données du formulaire principal (first-step)
    formData.append("first_name", this.f.name_fields?.first_name || "");
    formData.append("last_name", this.f.name_fields?.last_name || "");
    formData.append("password", this.f.password_fields?.password || "");
    formData.append("password_confirmation", this.f.password_fields?.password_confirmation || "");
    formData.append("role[]", this.f.role?.[0] || "");
    // Formater le numéro de téléphone avant l'envoi
    const formattedPhone = this.formatPhoneForSubmission(this.f.phone_field?.phone || "");
    const normalizedStreetAddress = this.normalizeTextForSubmission(this.f.address_fields?.address || "");
    const normalizedCity = this.normalizeTextForSubmission(this.f.address_fields?.city || "");
    const normalizedPostalCode = this.normalizePostalCodeForSubmission(this.f.address_fields?.zip_code || "");
    formData.append("phone", formattedPhone);
    formData.append("email", this.f.email?.email || "");
    formData.append("gender", this.f.gender_field?.gender || "");
    formData.append("birth_date", this.f.birthdate_field?.birth_date || "");
    formData.append("streetAddress", normalizedStreetAddress);
    formData.append("city", normalizedCity);
    formData.append("postalCode", normalizedPostalCode);
    // Utiliser le code pays (fr, de, it, etc.) au lieu du préfixe téléphonique
    formData.append("country", this.f.country_code || "fr");

    // Données spécifiques au prestataire (second-step)
    formData.append("type_pro", this.selectedTypeName);
    formData.append("experience", this.registerFormProvider.value.experience);
    formData.append("certification", this.registerFormProvider.value.diploma);
    formData.append("societe", this.registerFormProvider.value.societe);
    formData.append("statut_pro", "PENDING");
    formData.append(`domaine_id`, this.selectedDomainId!.toString());

    this.selectedSpecialiteList.forEach((speciality: any, index: any) => {
      formData.append(`speciality_id[${index}]`, speciality.toString());
    });

    // Traitement de la date de naissance pour compatibilité
    if (this.f.birthdate_field?.birth_date) {
      const birthDate = new Date(this.f.birthdate_field.birth_date);
      formData.append("birthDay", birthDate.getDate().toString());
      formData.append("birthMonth", (birthDate.getMonth() + 1).toString());
      formData.append("birthYear", birthDate.getFullYear().toString());
    }

    this.authService.createUser(formData).subscribe({
      next: (res: any) => {
        try {
          if (res.status === 201 || res.status === 200) {
            // La réponse peut être dans res.body.data ou directement dans res.body
            const response = res.body?.data || res.body;
            // Vérifications de sécurité
            if (!response) {
              console.error("Response is empty");
              this.isLoading = false;
              return;
            }

            const token = response.access_token;
            const user = response.user;
            const refresh = response.refresh_token;

            // Vérifier que les données essentielles existent
            if (!token || !user) {
              console.error("Missing token or user data", { token: !!token, user: !!user });
              this.isLoading = false;
              return;
            }

            // Traiter les rôles comme dans login.page.ts
            const processedUser = {
              ...user,
              roles: user.roles && Array.isArray(user.roles)
                ? user.roles.map((r: any) => typeof r === 'string' ? r : r.name)
                : (user.roles || [])
            };

            // Vérifier et obtenir le rôle de manière sécurisée
            const userRole = processedUser.roles && processedUser.roles.length > 0
              ? (typeof processedUser.roles[0] === 'string' ? processedUser.roles[0] : processedUser.roles[0].name)
              : this.role || 'client';


            // Sauvegarder les données d'authentification
            this.localStorageService.saveAuthDataFromLogin(
              token,
              processedUser,
              userRole,
              refresh
            );

            // Attendre un peu pour s'assurer que les données sont sauvegardées
            setTimeout(() => {
              // Appel de getCompletetion avec gestion d'erreur
              this.authService.getCompletetion(userRole).subscribe({
                next: (completionRes: any) => {
                  if (completionRes?.body?.profile_completion !== undefined) {
                    this.appService.setUserCompletion(completionRes.body.profile_completion);
                  }
                },
                error: (err) => {
                  console.error("Error getting completion:", err);
                  // Ne pas bloquer le processus si cette requête échoue
                }
              });

              // Initialisation Pusher avec gestion d'erreur
              this.pusherService.auth().subscribe({
                next: (pusherRes) => {
                  this.pusherService.subscribeToRoleChannel();
                  this.pusherService.subscribeToDiscussionChannel();
                },
                error: (err) => {
                  console.error("Error initializing Pusher:", err);
                  // Ne pas bloquer le processus si Pusher échoue
                }
              });
            }, 100);

            // Nettoyer l'état d'enregistrement
            this.clearRegisterStateAfterSuccess();

            // Naviguer vers la page appropriée selon le rôle (comme dans login)
            setTimeout(() => {
              if (userRole === "prestataire") {
                this.router.navigateByUrl("/prestataire", { replaceUrl: true });
              } else {
                this.router.navigateByUrl("/particulier", { replaceUrl: true });
              }
            }, 200);
          } else {
            console.error("Unexpected status code:", res.status);
          }
        } catch (error) {
          console.error("Error processing registration response:", error);
        } finally {
          this.isLoading = false;
        }
      },
      error: (errors: any) => {
        // this.submitted = false;
        this.isLoading = false;        // Gestion des erreurs Stripe
        if (this.stripeErrorHandler(errors.error)) {
          return;
        }
        // Gestion des autres erreurs
        let errorArray = errors.error;
        if (errorArray && errorArray.email) {
          this.emailError = true;
        }
        const message = this.buildFriendlyErrorMessage(errors);
        this.appService.presentToast(message, 'danger');
      },
    });
  }

  /**
   * Construit un message d'erreur plus explicite pour l'utilisateur
   */
  private buildFriendlyErrorMessage(err: any): string {
    try {
      const status = err?.status;
      const data = err?.error || {};

      // Priorité aux messages clairs envoyés par l'API
      if (typeof data.message === 'string' && data.message.trim().length > 0) {
        return data.message;
      }

      // Erreurs de validation de champs (ex: { errors: { email: [..], password: [..] } })
      if (data.errors && typeof data.errors === 'object') {
        const [[field, messages]] = Object.entries<any>(data.errors);
        const firstMessage = Array.isArray(messages) ? messages[0] : String(messages);
        return `${this.mapFieldLabel(field)}: ${firstMessage}`;
      }

      // Cas fréquents
      if (status === 0) return "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      if (status === 400) return "Requête invalide. Merci de vérifier les informations saisies.";
      if (status === 401) return "Votre session a expiré. Veuillez vous reconnecter.";
      if (status === 403) return "Action non autorisée.";
      if (status === 409) return "Un compte avec ces informations existe déjà.";
      if (status === 413) return "Fichier trop volumineux. Taille maximale: 2 Mo.";
      if (status === 422) return "Données invalides. Merci de corriger les champs indiqués.";
      if (status === 500) return "Erreur interne du serveur. Réessayez plus tard.";

      return "Une erreur est survenue lors de la création du compte.";
    } catch {
      return "Une erreur est survenue lors de la création du compte.";
    }
  }

  private mapFieldLabel(field: string = ''): string {
    const map: any = {
      email: 'Email',
      password: 'Mot de passe',
      first_name: 'Prénom',
      last_name: 'Nom',
      phone: 'Téléphone',
      birth_date: 'Date de naissance',
      type_pro: 'Type de société',
      societe: 'Nom de société',
      domaine_id: 'Domaine',
    };
    return map[field] || field;
  }

  processFile(event: any, type: DocType) {
    // Clear previous error for this document
    this.fileValidationErrors[type] = '';

    if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
      this.fileValidationErrors[type] = 'Aucun fichier sélectionné';
      this.cdr.detectChanges();
      return;
    }

    const file = event.target.files[0];

    // Vérifier que le fichier existe et est valide
    if (!file) {
      this.fileValidationErrors[type] = 'Fichier invalide ou corrompu';
      event.target.value = '';
      this.cdr.detectChanges();
      return;
    }

    // Vérifier le type de fichier
    if (!this.allowedMimeTypes.includes(file.type)) {
      const allowedTypes = ['JPEG', 'PNG', 'PDF', 'Word'];
      this.fileValidationErrors[type] = `Type de fichier non autorisé. Formats acceptés : ${allowedTypes.join(', ')}`;
      // Réinitialiser l'input file
      event.target.value = '';
      this.cdr.detectChanges();
      return;
    }

    // Vérifier la taille du fichier (2 Mo max)
    const maxSize = 2048 * 1024; // 2 Mo en octets
    if (file.size > maxSize) {
      const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
      this.fileValidationErrors[type] = `Fichier trop volumineux (${fileSizeMB} Mo). Taille maximale autorisée : 2 Mo`;
      // Réinitialiser l'input file
      event.target.value = '';
      this.cdr.detectChanges();
      return;
    }

    // Vérifier que le fichier n'est pas vide
    if (file.size === 0) {
      this.fileValidationErrors[type] = 'Le fichier sélectionné est vide';
      event.target.value = '';
      this.cdr.detectChanges();
      return;
    }

    // Fichier valide, l'accepter
    this.docs[type].file = file;
    this.docs[type].status = "PENDING";
    // Clear error for this doc
    this.missingDocErrors[type] = false;
    this.fileValidationErrors[type] = '';
    this.cdr.detectChanges();
  }

  /**
   * Get human-readable document name
   */
  private getDocumentName(type: DocType): string {
    const names: { [key in DocType]: string } = {
      'KBIS': 'KBIS',
      'URSSAF': 'URSSAF',
      'votre_photo': 'Photo',
      'Piece_d_identite': 'Pièce d\'identité'
    };
    return names[type] || type;
  }
  removeFile(type: DocType) {
    const doc = this.docs[type];
    if (doc) {
      this.updateFileMetadata(type);
      // Clear validation errors when file is removed
      this.fileValidationErrors[type] = '';
      // If removed, re-flag as error only after submit
      if (this.submitted) {
        const isAccepted = this.docs[type].status === 'ACCEPTED';
        const hasFile = !!this.docs[type].file;
        this.missingDocErrors[type] = !(isAccepted || hasFile);
      }
      this.cdr.detectChanges();
    }
  }
  updateFileMetadata(type: DocType) {
    switch (type) {
      case "KBIS":
      case "URSSAF":
      case "votre_photo":
      case "Piece_d_identite":
        if (this.docs[type].status != "ACCEPTED") {
          this.docs[type].file = null;
          this.docs[type].status = "EMPTY";
        }
        break;
      default:
        console.warn(`Unknown document type: ${type}`);
    }
  }
  getDocImage(status: string) {
    let image = "doc-upload.png";
    switch (status) {
      case "PENDING":
        image = "pending.svg";
        break;
      case "ACCEPTED":
        image = "pdf.svg";
        break;

      default:
        image = "doc-upload.png";
        break;
    }
    return image;
  }
  isFileSelected(index: number): boolean {
    const isEmpty = this.files[index]?.length === 0;
    return !isEmpty;
  }

  handleChange(val: any) {
    this.domainSelected = true;
    this.domaineId = val;
    this.appService
      .getSpecialitysByIds({ domain_ids: val })
      .subscribe((res: any) => {
        this.specialityList = res.body
          .map((item: any) => item.specialities)
          .flat();
        if (this.specialityList.length > 0) {
          this.isSpeciality = true;
        }
      });
  }

  goToLogin() {
    this.router.navigate(["/"]);
  }
  typeCompany(businessType: string) {
    switch (businessType) {
      case "EIRL":
        return "Entreprise individuelle à responsabilité limitée (EIRL)";
      case "EURL":
        return "Entreprise unipersonnelle à responsabilité limitée (EURL)";
      case "SARL":
        return "Société à responsabilité limitée (SARL)";
      case "SAS":
        return "Société par actions simplifiée (SAS)";
      case "EL":
        return "Entreprise individuelle (EI)";
      case "Entreprise publique":
        return "Entreprise publique (EP)";
      case "ESS":
        return "Economie sociale et solidaire (ESS)";
      case "SA":
        return "Société anonyme (SA)";
      default:
        return businessType;
    }
  }

  openDomain(val: boolean) {
    this.domanModal = val;
  }
  openSpecialteModal(val: boolean) {
    this.specialteModal = val;
  }
  openTypeModal(val: boolean) {
    this.typeModal = val;
  }
  openCGVModal(val: boolean) {
    this.cgvModal = val;
  }
  selectDomain(domain: any) {
    this.selectedDomainId1 = domain.id;
    this.selectedDomainName1 = domain.nom;
  }

  selectType(type: any) {
    this.selectedTypeId1 = type;
    this.selectedTypeName1 = type;
  }
  selectSpecialite(pecialite: any) {
    this.toggleObjectInArray(pecialite, this.selectedSpecialiteList1);
  }

  toggleObjectInArray(object: any, array: any[]): void {
    const index = array.findIndex(
      (item) => item.id === object.id /* Compare objects here */
    );
    if (index !== -1) {
      array.splice(index, 1);
    } else {
      array.push(object);
    }
  }

  assureSelectType() {
    this.selectedTypeId = this.selectedTypeId1;
    this.selectedTypeName = this.selectedTypeName1;
    this.companyTypeSelected = true;
    this.openTypeModal(false);
  }
  assureSelectDomain() {
    this.selectedDomainId = this.selectedDomainId1;
    this.selectedDomainName = this.selectedDomainName1;
    this.domainSelected = true;
    let valArray = [this.selectedDomainId1];
    this.handleChange(valArray);
    this.openDomain(false);
    this.resetSpecialteList();
  }

  resetSpecialteList() {
    this.selectedSpecialiteList1 = [];
    this.selectedSpecialiteList = [];
    this.selectedSpecialiteList = [];
    this.selectedSpecialiteName = "";
    this.specialitySelected = false;
  }

  assureSelectSpecialite() {
    if (this.selectedSpecialiteList1.length) {
      this.selectedSpecialiteList = this.selectedSpecialiteList1.map(
        (item: any) => item.id
      );
      let namesList = this.selectedSpecialiteList1.map((item: any) => item.nom);
      this.selectedSpecialiteName = namesList.join(",");
      this.specialitySelected = true;
    } else {
      this.specialitySelected = false;
    }
    this.openSpecialteModal(false);
  }
  isSelectedSpecialite(speciality: any): boolean {
    let exist = this.selectedSpecialiteList.some(
      (item) => item === speciality.id
    );
    return exist;
  }
  isSelectedDomaine(domaine_id: number): boolean {
    let exist = this.selectedDomainId === domaine_id;
    return exist;
  }
  isSelectedType(type: string): boolean {
    let exist = this.selectedTypeName === type;
    return exist;
  }

  onDeleteSelectedSpecialite(item: any) {
    this.toggleObjectInArray(item, this.selectedSpecialiteList1);
    this.selectedSpecialiteList = this.selectedSpecialiteList1;
    if (this.selectedSpecialiteList.length === 0) {
      this.selectedSpecialiteList = [];
      this.specialitySelected = false;
      this.selectedSpecialiteName = "Choisissez le type de spécialité";
    } else {
      this.selectedSpecialiteList = this.selectedSpecialiteList1.map(
        (item: any) => item.id
      );
      let namesList = this.selectedSpecialiteList1.map((item: any) => item.nom);
      this.selectedSpecialiteName = namesList.join(", ");
    }
  }

  /**
   * Restore form data from session storage
   */
  private restoreFormData(): void {
    const savedData = this.sessionStorageService.getRegisterSecondStep();
    if (savedData) {
      // Restore form values
      this.registerFormProvider.patchValue(savedData);

      // Restore selections
      if (savedData.selectedDomainId) {
        this.selectedDomainId = savedData.selectedDomainId;
        this.selectedDomainName = savedData.selectedDomainName || '';
        this.domainSelected = true;

        // Load specialties for the selected domain
        if (this.domainList.length > 0) {
          this.handleChange([savedData.selectedDomainId]);
        }
      }

      if (savedData.selectedTypeName) {
        this.selectedTypeName = savedData.selectedTypeName;
        this.selectedTypeId = savedData.selectedTypeId;
        this.companyTypeSelected = true;
      }

      if (savedData.selectedSpecialiteList) {
        this.selectedSpecialiteList = savedData.selectedSpecialiteList;
        this.selectedSpecialiteName = savedData.selectedSpecialiteName || '';
        this.specialitySelected = true;
      }

      if (savedData.documents) {
        // Restore documents with files properly restored from base64
        this.docs = { ...savedData.documents };
        // Ensure all document properties are properly restored
        for (const [key, doc] of Object.entries(this.docs)) {
          const docData = doc as any;
          if (docData && !docData.file && docData.status !== 'ACCEPTED') {
            // If file is missing and not accepted, reset to EMPTY
            this.docs[key] = {
              file: null,
              type: docData.type,
              status: 'EMPTY'
            };
          }
          // Clear validation errors when restoring
          this.fileValidationErrors[key as DocType] = '';
        }
        // Trigger change detection to update UI
        this.cdr.detectChanges();
      }
    }
  }

  /**
   * Auto-save form data to session storage
   */
  private async autoSaveFormData(): Promise<void> {
    const formData: SecondStepData = {
      ...this.registerFormProvider.value,
      selectedDomainId: this.selectedDomainId,
      selectedDomainName: this.selectedDomainName,
      selectedTypeId: this.selectedTypeId,
      selectedTypeName: this.selectedTypeName,
      selectedSpecialiteName: this.selectedSpecialiteName,
      selectedSpecialiteList: this.selectedSpecialiteList,
      documents: this.docs
    };

    await this.sessionStorageService.saveRegisterSecondStep(formData);
  }

  /**
   * Save form data manually (called on step transitions)
   */
  public async saveFormData(): Promise<void> {
    const formData: SecondStepData = {
      ...this.registerFormProvider.value,
      selectedDomainId: this.selectedDomainId,
      selectedDomainName: this.selectedDomainName,
      selectedTypeId: this.selectedTypeId,
      selectedTypeName: this.selectedTypeName,
      selectedSpecialiteName: this.selectedSpecialiteName,
      selectedSpecialiteList: this.selectedSpecialiteList,
      documents: this.docs
    };

    await this.sessionStorageService.saveRegisterSecondStep(formData);
  }

  /**
   * Clear saved form data
   */
  public clearSavedFormData(): void {
    this.sessionStorageService.clearRegisterState();
  }

  /**
   * Get saved form data
   */
  public getSavedFormData(): SecondStepData | null {
    return this.sessionStorageService.getRegisterSecondStep();
  }

  /**
   * Clear register state after successful registration
   */
  public clearRegisterStateAfterSuccess(): void {
    this.sessionStorageService.clearRegisterState();
  }
}
